<div class="card card--no-padding">
  <div class="user-stats">
    <div class="user-stats__item">
      <div class="user-stats__number">{{ todayMaxActiveUsers() }}</div>
      <div class="user-stats__text">{{ "Wireless.Stats.Today" | translate }}</div>
    </div>
    <div class="user-stats__item">
      <div class="user-stats__number">{{ last3DaysMaxActiveUsers() }}</div>
      <div class="user-stats__text">{{ "Wireless.Stats.3Days" | translate }}</div>
    </div>
    <div class="user-stats__item">
      <div class="user-stats__number">{{ lastWeekMaxActiveUsers() }}</div>
      <div class="user-stats__text">{{ "Wireless.Stats.LastWeek" | translate }}</div>
    </div>
  </div>
</div>
